import { getPriceText } from '../../../../../../shared/utils/string/getPriceText';

export const getAcceptButtonText = (price: number, abGroup: string | null) => {
  if (price && abGroup === 'C') {
    return `Разместить за ${getPriceText(price)}`;
  }

  return 'Разместить на других площадках';
};
